import React, { useState, useContext, useEffect } from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import {UserProvider} from './utils/usercontext';
import {WebContext, WebProvider} from './webcontext';

import Header from './routes/header';
import Footer from './routes/footer';

import HomePage from './routes/index';
import About from './routes/about';
import Chat from './routes/chat';
import Listen from './routes/listen';
import Schedule from './routes/schedule';
import Previous from './routes/previous';
import OurDJs from './routes/ourdjs';
import JoinUs from './routes/joinus';

//import 'bootstrap/dist/css/bootstrap.min.css';

//import './routes/css/main.css';
//import './routes/css/index.css';

const SetWeb = (props) => {
  const value = useContext(WebContext);
  //console.log(value);

  switch(value.web?.service.template) {
    case 2:
      import('./routes/css/2-index.css');
    break;
    case 1:
      import('bootstrap/dist/css/bootstrap.min.css');
      import('./routes/css/1-main.css');
      //require('./routes/css/1-index.css');
    break;
    default:
    break;
  }
  return Object.keys(value.web).length === 0 ? <></> : (
    
    <>{props.children}</>
  )
}


function App() {
  const [services] = useState(['restream', 'emojicrew', 'emojichat', 'radio', 'radio suite']);
  
  return (
    <UserProvider>
      <WebProvider>
        <SetWeb>
          <BrowserRouter>
            <Header services={services} />
            <Routes>

              {/*---- Home page ----*/}
              <Route path="/" exact element={<HomePage />} />
              <Route path="/about" exact element={<About />} />
              <Route path="/chat" exact element={<Chat />} />
              <Route path="/listen" exact element={<Listen />} />
              <Route path="/schedule" exact element={<Schedule />} />
              <Route path="/previous" exact element={<Previous />} />
              <Route path="/ourdjs" exact element={<OurDJs />} />
              <Route path="/joinus" exact element={<JoinUs />} />
              

              

              {/*---- Docs ----*/}


              {/*---- Policies ----*/}

              
            </Routes>
            <Footer services={services} />
            {/*<Socket />*/}
          </BrowserRouter>
        </SetWeb>
      </WebProvider>
    </UserProvider>
  );
}

export default App;
